import gql from 'graphql-tag';

export default gql`
  query indexPageImages {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        images(section: "operatorLogos") {
          id
          path
          alt
          title
        }
      }
    }
  }
`;
